import { QueryHookOptions } from '@apollo/client';

import {
  AudienceFilter,
  AudiencesQueryVariables,
  PartialAudienceFragment,
  useAudiencesQuery,
} from '@occc/graphql';

import { transformDataToAudiencesArray } from './utils';

import { PaginationInfo, usePaginatedQuery } from '../../hooks/usePaginatedQuery';

interface GetAudiencesProps {
  filter: AudienceFilter;
  pageSize?: number;
  baseOptions?: QueryHookOptions<PartialAudienceFragment[], AudiencesQueryVariables>;
  paginationInfo?: PaginationInfo;
  onPageChange?: (info: PaginationInfo) => void;
}

// TODO: All hooks that we use to query data with pagination look very similar.
// I think we should create a reusable hook that receives a number of properties and gives the same result.
// Thus, we will be able to avoid code duplication.
export const useGetAudiences = ({
  filter,
  pageSize,
  baseOptions,
  paginationInfo,
  onPageChange,
}: GetAudiencesProps) => {
  const response = usePaginatedQuery(
    useAudiencesQuery,
    'audiences.pageInfo',
    pageSize,
    {
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      variables: {
        filter,
      },
      ...baseOptions,
      onCompleted: (data) => {
        if (baseOptions && baseOptions.onCompleted) {
          baseOptions.onCompleted(transformDataToAudiencesArray(data));
        }
      },
    } as QueryHookOptions,
    paginationInfo,
    onPageChange,
  );

  return {
    ...response,
    data: response.data ? transformDataToAudiencesArray(response.data) : response.data,
  };
};
